export default __webpack_public_path__ + "static/media/orisa.192c2040.webp";